module.exports = __webpack_public_path__ + "static/media/cover14.2ecae179.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover14.png
// module id = 567
// module chunks = 0